import React from 'react';

const StudentProfile = () => (
  <div style={{ textAlign: 'center', marginTop: '3rem' }}>
    <h1>Student Profile</h1>
    <p>This page will show the student's profile details.</p>
  </div>
);

export default StudentProfile;